export * from "./HeadingTypeOne";